import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class AccountService extends RLBaseService {
    static $inject = ["$resource", "$q"];

    getAclsPromises: { [key: string]: ng.IPromise<string[]> } = {};

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getAppUrlId() {
        return this.toRLService<any>("/api/account/getappurlid").get().$promise;
	}

    generateGoogleAuthenticatorKey() {
        return this.toRLService<Models.IGenerateGoogleAuthenticatorKeyResponse>("/api/account/generategoogleauthenticatorkey").post().$promise;
    }

    confirmGoogleAuthenticatorKey(secretKey: string, code: string) {
        var data = {
            secretKey: secretKey,
            code: code
        };
        return this.toRLService<Models.IDataResponse<any>>("/api/account/confirmgoogleauthenticatorkey").post(data).$promise;
    }

    getAccountManageState() {
        return this.toRLService<Models.IAccountManageState>("/api/account/getaccountmanagestate").get().$promise;
    }

    removeGoogleAuthenticator(password: string) {
        var data = {
            password: password
        };
        return this.toRLService<void>("/api/account/removegoogleauthenticator").post(data).$promise;
    }

    saveProfileAvatar(avatar: string) {
        var data = {
            avatar: avatar
        };
        return this.toRLService<Models.IDataResponse<any>>("/api/account/saveprofileavatar").post(data).$promise;
    }

    getAcls(policyType: number = null) {
        var key = policyType || -1;
        if (this.getAclsPromises[key] == null) {
            var data: any = {};
            if (policyType != null) {
                data.policyType = policyType;
            }
            var promise = this.toRLService<string>("/api/account/getacls").query(data).$promise;
            this.getAclsPromises[key] = promise;
            promise.finally(() => {
                delete this.getAclsPromises[key];
            });
        }
        return this.getAclsPromises[key];
    }

    getRealAclState() {
        return this.toRLService<{ state: boolean }>("/api/account/getrealaclstate").get().$promise;
    }

    setRealAclState(state: boolean) {
        var data = {
            state: state
        }
        return this.toRLService<void>("/api/account/setrealaclstate").post(data).$promise;
    }

    getCustomColumns(charTypeID?: number) {
        return this.toRLService<Models.ICustomUserColumns>("/api/Account/GetCustomUserColumns").getArray({ charTypeID: charTypeID }).$promise;
    }

    createCustomColumns(customColumns: Models.ICustomUserColumns) {
        return this.toRLService<number>("/api/Account/CreateCustomUserColumns").post(customColumns).$promise;
    }

    deleteCustomColumns(headerID: number) {
        return this.toRLService<Models.ICustomUserColumns[]>("/api/Account/DeleteCustomUserColumns").delete({ headerID: headerID }).$promise;
    }

    getLoginOptions(email: string) {
        return this.toRLService<{ showPassword: boolean, showSSO: boolean, ssoEndpoint: string, ssoAuthNRequest: string, ssoAppUrlID: number }>("/api/account/getloginoptions").get({ email: email }).$promise;
    }

    login(email: string, password: string, rememberMe: boolean) {
        var data = {
            userName: email,
            password: password,
            rememberMe: rememberMe
        };
        return this.toRLService<{ result: "choose_application" | "require_pw_reset" | "success" | "locked_out" | "two_factor" | "incomplete_profile" | "failure", message: string }>("/api/account/login").post(data).$promise;
	}

	checkIfJiraAccountExists() {
		return this.toRLService<{ hasAccount : boolean }>("/api/Account/JiraAccountExists").get().$promise;
	}

	createJiraAccount() {
		return this.toRLService<{ accountCreated: boolean }>("api/Account/CreateJiraAccount").get().$promise;
	}

	sendJiraResetPasswordEmail() {
		return this.toRLService<void>("api/Account/ResetJiraPassword").post().$promise;
	}

}
